import { c as _c } from "react/compiler-runtime";
import { QAList, type Question } from '../_components/QAList';
const invoiceDbQuestions: Question[] = [{
  title: 'Jakie formy płatności są dostępne?',
  content: <>
        Płatności obsługuje{' '}
        <a href='https://stripe.com/en-pl/customers' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Stripe
        </a>{' '}
        - najpopularniejsza na świecie bramka płatnicza (międzynarodowy odpowiednik{' '}
        <a href='https://przelewy24.pl' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Przelewy24
        </a>{' '}
        lub{' '}
        <a href='https://www.payu.pl' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          PayU
        </a>
        ), która obsługuje karty, BLIK i inne metody płatności. Wszystkie szczegóły znajdziesz na
        ich stronie.
      </>
}, {
  title: 'Czy mogę otrzymać fakturę za zakupione usługi?',
  content: 'Wystawiamy fakturę za wszystkie nasze usługi - wysyłamy ją na Twój adres e-mail.'
}, {
  title: 'Jak działają płatności za mentoring?',
  content: <>
        Mentoring to subskrypcja - płacisz co 4 tygodnie, 12 tygodni lub rok. Płatności odnawiają
        się automatycznie przez{' '}
        <a href='https://stripe.com/en-pl/customers' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Stripe
        </a>
        . Możesz zrezygnować w każdej chwili.
      </>
}];
export function QAInvoiceSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={invoiceDbQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}